import { render } from "./AdvancedVideoPlayer.vue?vue&type=template&id=52d171d3"
import script from "./AdvancedVideoPlayer.vue?vue&type=script&lang=js"
export * from "./AdvancedVideoPlayer.vue?vue&type=script&lang=js"

import "./AdvancedVideoPlayer.vue?vue&type=style&index=0&id=52d171d3&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__